import React, {useState} from "react";
import {OptiselModal} from "../../components/modal/OptiselModal";

/**
 * Dialog archiwizacji sprawy — powód jest obowiązkowy (przycisk zablokowany dla pustego tekstu).
 * Po sukcesie pokazuje potwierdzenie, a "OK" oddaje sterowanie stronie przez onArchivedConfirmed
 * (nawigacja na listing spraw).
 */
export function IssueArchiveModal(props: {
    issueName: string,
    opened: boolean,
    onClose: () => void,
    archiveWithReason: (reason: string) => Promise<void>,
    onArchivedConfirmed: () => void,
}) {
    const [reason, setReason] = useState("");
    const [phase, setPhase] = useState<"form" | "saving" | "archived">("form");

    const performArchive = () => {
        setPhase("saving");
        props.archiveWithReason(reason.trim()).then(() => {
            setPhase("archived");
        }).catch(() => {
            window.alert("Nie udało się zarchiwizować sprawy. Spróbuj ponownie.");
            setPhase("form");
        });
    };

    if (phase === "archived") {
        return <OptiselModal opened={props.opened} header={"Sprawa zarchiwizowana"} closeable={false} onClose={props.onArchivedConfirmed}>
            <p>Sprawa <strong>{props.issueName}</strong> została zarchiwizowana.</p>
            <div className={"d-flex justify-content-end"}>
                <button className={"btn btn-primary"} onClick={props.onArchivedConfirmed}>OK</button>
            </div>
        </OptiselModal>;
    }

    return <OptiselModal opened={props.opened} header={"Archiwizacja sprawy"} closeable={false} onClose={props.onClose}>
        <p>Sprawa <strong>{props.issueName}</strong> zostanie przeniesiona do archiwum. Podanie powodu jest wymagane.</p>
        <div className="mb-3">
            <label className="form-label fw-bolder" htmlFor="issue-archive-reason">Powód archiwizacji</label>
            <textarea id="issue-archive-reason" className="form-control" rows={3} value={reason}
                      onChange={e => setReason(e.target.value)}/>
        </div>
        <div className={"d-flex gap-2 justify-content-end"}>
            <button className={"btn btn-secondary"} onClick={props.onClose} disabled={phase === "saving"}>Anuluj</button>
            <button className={"btn btn-danger"} onClick={performArchive} disabled={reason.trim() === "" || phase === "saving"}>
                {phase === "saving" ? <><i className="fas fa-spinner fa-spin me-2"/>Archiwizowanie…</> : <><i className={"fas fa-archive"}/> Archiwizuj</>}
            </button>
        </div>
    </OptiselModal>;
}
